export default __webpack_public_path__ + "src/assets/logo.47f78a846dfb8a8f69df4247d9c43857.svg";